<template>
  <div
    :class="[
      'sidebar-container ',
      { active: Sidebar },
      { ' mobile-sidebar ': getMobileSidebar },
    ]"
  >
    <!-- <div>{{ $store.state.user.userProfile }}</div> -->
    <div class="brand-container">
      <button
        class="btn-sidebar-toggler"
        v-on:click="toggleSidebar()"
        v-if="!isMobile"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div v-if="!isGoGoCinema">
        <img
          src="@/assets/img/logos/logo-light.png"
          height="auto"
          width="100"
          class="ml-2 c-pointer"
          @click="goHome"
        />
      </div>
    </div>

    <div class="links-container">
      <ul class="sidebar-nav" v-if="SideNav.length > 0">
        <li v-for="(Nav, index) in SideNav" :key="index" v-on:click="onsidebar">
          <div v-if="Nav.hasOwnProperty('permissions')">
            <div v-if="Nav.children && Nav.children.length > 0">
              <div
                class="parent-nav"
                :class="Nav.isCollapsed ? null : 'collapsed'"
                :aria-expanded="Nav.isCollapsed ? 'true' : 'false'"
                :aria-controls="'parentNav-lvl-1-' + index"
                @click="onHandleCollapsed(SideNav, index)"
              >
                <div :class="Nav.icon + ' nav-icon'"></div>

                <div class="nav-title">
                  {{ $tc(Nav.name, 2) }}
                </div>
              </div>
              <sidebar-dropdown
                v-if="Nav.children"
                :index="index"
                :children="Nav.children"
                :isCollapsed="Nav.isCollapsed"
                :onHandleCollapsed="onHandleCollapsed"
              />
            </div>

            <router-link
              v-else-if="Nav.hasOwnProperty('show') ? Nav.show : true"
              :to="Nav.url"
              class="parent-nav"
            >
              <span :class="Nav.icon + ' nav-icon'"></span>
              <div class="nav-title">{{ Nav.name }}</div>
            </router-link>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import Nav from "@/NavHybrid";
  import { mapGetters, mapActions } from "vuex";
  import { checkAccessController, checkParentId } from "@/helper/AccessControl";
  import sidebarDropdown from "./sidebarDropdown.vue";
  import UserService from "@/services/UserService";

  export default {
    components: {
      "sidebar-dropdown": sidebarDropdown,
    },
    data() {
      return {
        // SideNav: Nav.items,
        SideNav: [],
        Sidebar: true,
        openCollapseId: null,
        fnbactive: false,
        isSidebarShow: true,
        modules: [],
        array_new_module: [],
        count: 0,
      };
    },
    watch: {
      $route(to, from) {
        this.makeAllCollapseFalse();
        this.SideNav.map((x, index) => {
          this.collapseRouteCheck(x, to, x);
        });
      },
      "$store.state.user.userProfile": function(newVal, oldVal) {
        this.setNavItems();
      },
    },
    computed: {
      getGLobalOption() {
        return this.secureStore.get("MYCINEMASTATUS") || "N";
      },
      isGoGoCinema() {
        let isGogoCinema =
          this.$store.getters.isGogoCinema == "Y" ? true : false;
        return isGogoCinema;
      },
      ...mapGetters([
        "getCurrentSideNavRoute",
        "getMobileSidebar",
        // "getUserProfile",
      ]),
      isMobile() {
        return this.$store.getters.getIsMobile;
      },
    },
    beforeMount() {
      this.setNavItems();
      let fnbvalue = this.secureStore.get("ENABLE_FNB");
      let roleid =
        this.secureStore.get("USINFO") && this.secureStore.get("USINFO").role_id
          ? this.secureStore.get("USINFO").role_id
          : null;
      if (roleid && roleid == 1 && fnbvalue == "N") {
        this.fnbactive = true;
      }
      this.getModuleList();
    },
    mounted() {},
    methods: {
      setNavItems() {
        const navItems = Nav.items;
        const filteredNavArr = [];
        for (const item of navItems) {
          const obj = {
            ...item,
          };

          if (item.children && item.children.length) {
            const children = [];
            for (const child of item.children) {
              if (child.children && child.children.length) {
                const subChilds = [];
                for (const subChild of child.children) {
                  if (
                    subChild.action &&
                    subChild.resource &&
                    this.$can(subChild.action, subChild.resource)
                  ) {
                    subChilds.push(subChild);
                  } else if (!subChild.action || !subChild.resource) {
                    subChilds.push(subChild);
                  }
                }

                if (!subChilds.length) continue;

                child.children = subChilds;
              }

              if (
                child.action &&
                child.resource &&
                this.$can(child.action, child.resource)
              ) {
                children.push(child);
              } else if (!child.action || !child.resource) {
                children.push(child);
              }
            }
            obj.children = children;
          }

          filteredNavArr.push(obj);
        }

        this.SideNav = filteredNavArr.filter((item) => {
          return item.children.length > 0;
        });

        this.$forceUpdate();
      },
      makeAllCollapseFalse() {
        this.SideNav.map((x, _index) => {
          if (x.hasOwnProperty("children")) {
            x.children.map((y) => {
              if (y.hasOwnProperty("children")) {
                y.children.map((z) => {
                  z["isCollapsed"] = false;
                  x["isCollapsed"] = false;
                  y["isCollapsed"] = false;
                });
              } else {
                x["isCollapsed"] = false;
                y["isCollapsed"] = false;
              }
            });
          } else {
            x["isCollapsed"] = false;
          }
        });
      },
      collapseRouteCheck(x, to, initialObj) {
        if (x.hasOwnProperty("children")) {
          x.children.map((y) => {
            if (y.hasOwnProperty("children")) {
              y.children.map((z) => {
                if (z.url == to.fullPath) {
                  z["isCollapsed"] = true;
                  y["isCollapsed"] = true;
                  x["isCollapsed"] = true;
                } else {
                  z["isCollapsed"] = false;
                }
              });
            } else {
              if (y.url == to.fullPath) {
                x["isCollapsed"] = true;
                y["isCollapsed"] = true;
              } else {
                y["isCollapsed"] = false;
              }
            }
          });
        } else {
          if (x.url == to.fullPath) {
            x["isCollapsed"] = true;
          } else {
            x["isCollapsed"] = false;
          }
        }
      },
      checkArrayModuleNew(x, startObj) {
        x["show"] = true;

        if (this.isGoGoCinema && x.hasOwnProperty("GogoName")) {
          x["name"] = x.GogoName;
        }
        if (this.CLIENT_SETUP_NAME && x.hasOwnProperty("only_available_on")) {
          let checkKeyExist = x.only_available_on.filter((zzz) => {
            return zzz.key_name == this.CLIENT_SETUP_NAME;
          });
          if (checkKeyExist.length > 0) {
            x["url"] = checkKeyExist[0].url;
          }
        }

        if (x.hasOwnProperty("only_visible_on")) {
          if (this.CLIENT_SETUP_NAME) {
            let checkKeyExist = x.only_visible_on.filter((ovo) => {
              return ovo.key_name == this.CLIENT_SETUP_NAME;
            });

            if (checkKeyExist.length > 0) {
              x["show"] = true;
            } else {
              x["show"] = false;
            }
          } else {
            x["show"] = false;
          }
        }
        if (x.hasOwnProperty("children") && x["show"]) {
          x.children.map((y) => {
            if (
              this.CLIENT_SETUP_NAME &&
              y.hasOwnProperty("only_available_on")
            ) {
              let checkKeyExist = y.only_available_on.filter((zzz) => {
                return zzz.key_name == this.CLIENT_SETUP_NAME;
              });
              if (checkKeyExist.length > 0) {
                y["url"] = checkKeyExist[0].url;
              }
            }

            if (y.hasOwnProperty("only_visible_on")) {
              if (this.CLIENT_SETUP_NAME) {
                let checkKeyExist = y.only_visible_on.filter((ovo) => {
                  return ovo.key_name == this.CLIENT_SETUP_NAME;
                });

                if (checkKeyExist.length > 0) {
                  y["show"] = true;
                } else {
                  y["show"] = false;
                }
              } else {
                y["show"] = false;
              }
            }
            if (this.isGoGoCinema && y.hasOwnProperty("GogoName")) {
              y["name"] = y.GogoName;
            }
            if (y.hasOwnProperty("children")) {
              y["isChildrenExist"] = false;
              this.checkArrayModuleNew(y, startObj);
            } else {
              let checkModule = this.modules.filter((z) => {
                return z.module_id == y.module_id;
              });
              if (checkModule.length > 0) {
                if (checkModule[0].module_is_active == "Y") {
                  x["show"] = true;
                  y["ModuleId"] = "1";
                  if (x.hasOwnProperty("isChildrenExist")) {
                    x["isChildrenExist"] = true;
                  }
                  startObj["isChildrenExist"] = true;
                } else {
                  x["show"] = false;
                  y["ModuleId"] = "2";
                }
              } else {
                y["show"] = true;
                y["ModuleId"] = "3";
              }
            }
          });
        } else if (x["show"]) {
          let checkModule = this.modules.filter((z) => {
            return z.module_id == x.module_id;
          });
          if (checkModule.length > 0) {
            if (checkModule[0].module_is_active == "Y") {
              x["show"] = true;
              y["ModuleId"] = "1";
              if (x.hasOwnProperty("isChildrenExist")) {
                x["isChildrenExist"] = true;
              }
              startObj["isChildrenExist"] = true;
            } else {
              x["show"] = false;
              y["ModuleId"] = "2";
            }
          } else {
            y["show"] = true;
            y["ModuleId"] = "3";
          }
        }
      },
      checkArrayModule(x, index) {
        // let array_new=[];
        // let array_not_available=[];
        if (x.hasOwnProperty("children")) {
          let obj = {
            icon: x.icon,
            isCollapsed: x.isCollapsed,
            name: x.name,
            show: x.show,
            url: x.url,
            permissions: x.permissions,
            children: [],
          };
          x.children.map((y, index1) => {
            if (y.hasOwnProperty("children")) {
              this.checkArrayModule(y, index1);
            } else {
              let checkModule = this.modules.filter((z) => {
                return z.module_id == y.module_id;
              });
              if (checkModule.length > 0) {
                if (checkModule[0].module_is_active == "Y") {
                  obj.children.push(y);
                }
              } else {
                obj.children.push(y);
                //  array_not_available.push(y)
              }
            }
          });
          this.array_new_module.push(obj);
        } else {
          let checkModule = this.modules.filter((z) => {
            return z.module_id == x.module_id;
          });
          if (checkModule.length > 0) {
            if (checkModule[0].module_is_active == "Y") {
              this.array_new_module.push(x);
            }
          } else {
            this.array_new_module.push(x);
          }
        }
      },
      getModuleList: function() {
        let loader = this.$loading.show();

        UserService.ModulesList()
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.modules = data.Records;

              Nav.items.map((x) => {
                this.count = 1;

                if (x.name != "Home") {
                  x["isChildrenExist"] = false;
                  this.checkArrayModuleNew(x, x);
                } else {
                  x["isChildrenExist"] = true;
                }
              });
              setTimeout(() => {
                loader.hide();
              }, 2500);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      ...mapActions(["setCurrentSideNavRoute"]),
      toggleSidebar: function() {
        this.Sidebar = !this.Sidebar;
        if (!this.Sidebar) {
          this.SideNav.map((x, _index) => {
            x.isCollapsed = false;
          });
        }
      },
      onsidebar() {
        if (this.Sidebar == false) {
          this.toggleSidebar();
        }
      },
      onHandleCollapsed(parentNav, index) {
        if (parentNav[index].isCollapsed) {
          parentNav[index].isCollapsed = false;
        } else {
          parentNav.map((item, _index) => {
            if (_index === index) {
              item.isCollapsed = true;
            } else {
              item.isCollapsed = false;
            }
          });
        }
      },
      checkNavPermissions: function(Nav, direct_sale_flag, module_id, nav1) {
        return checkAccessController(module_id);
      },
      goHome() {
        this.$router.replace("/");
      },
    },
  };
</script>

<style>
  .sidebar-nav .show {
    border-bottom: 1px solid white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Containers/sidebar.vue